module.exports = __webpack_public_path__ + "img/google-logo.62f41cf0.png";